<template>
  <v-dialog v-model="dialog" fullscreen scrollable>
    <template v-slot:activator="{ on }">
      <div class="j-select no-before" v-on="on" @click.stop.prevent>
        <v-select
          v-if="simpleItem"
          :solo="solo"
          :solo-inverted="soloInverted"
          :prepend-inner-icon="prependInnerIcon"
          :label="label"
          :value="value"
          :items="[...items, ...addedValue]"
          :hide-details="hideDetails"
          :filled="filled"
          :dense="dense"
          :single-line="singleLine"
          :chips="chips"
          :multiple="multiple"
        ></v-select>
        <v-select
          v-else
          :solo="solo"
          :solo-inverted="soloInverted"
          :prepend-inner-icon="prependInnerIcon"
          :label="label"
          :value="value"
          :items="items"
          :item-text="itemText"
          :item-value="itemKey"
          :hide-details="hideDetails"
          :filled="filled"
          :dense="dense"
          :single-line="singleLine"
          :chips="chips"
          :multiple="multiple"
        ></v-select>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span style="max-width: 250px;">{{ label }}</span>
          <v-btn icon text @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
        <v-row align="center">
          <v-col style="flex-grow: 1; flex-shrink: 0;">
            <v-text-field
              v-if="comboBox"
              hide-details
              filled
              single-line
              dense
              class="no-before"
              v-model="search"
              label="Recherche/Ajout"
              @keydown.enter="addValue"
            ></v-text-field>
            <v-text-field
              v-else
              hide-details
              filled
              single-line
              dense
              class="no-before"
              prepend-inner-icon="fa-search"
              label="Recherche"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col
            v-if="comboBox"
            align-self="center"
            style="flex-grow: 0; flex-shrink: 1;"
          >
            <v-btn
              :disabled="search === null || search === ''"
              large
              icon
              text
              color="success"
              @click="addValue"
            >
              <v-icon large>fa-plus-square</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-list dense>
          <SelectItem
            v-for="item in [...items]
              .sort((a, b) => compareSelected(a, b))
              .filter(x =>
                simpleItem ? x.includes(search) : x[itemText].includes(search)
              )"
            :key="item[itemKey]"
            :item="item"
            :selected="isSelected(item)"
            :itemText="itemText"
            :itemKey="itemKey"
            :simpleItem="simpleItem"
            @change="selectionHandler"
          ></SelectItem>
          <SelectItem
            v-for="item in [...addedValue]
              .sort((a, b) => compareSelected(a, b))
              .filter(x =>
                simpleItem ? x.includes(search) : x[itemText].includes(search)
              )"
            :key="item[itemKey]"
            :item="item"
            :selected="isSelected(item)"
            :itemText="itemText"
            :itemKey="itemKey"
            :simpleItem="simpleItem"
            @change="selectionHandler"
          ></SelectItem>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="dialog = false">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectItem from "./SelectItem";
export default {
  name: "Select",
  components: {
    SelectItem
  },
  props: {
    value: {
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemKey: {
      type: String,
      default: "id"
    },
    simpleItem: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    comboBox: {
      type: Boolean,
      default: false
    },
    hashtag: {
      type: Boolean,
      default: false
    },
    prependInnerIcon: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialog: false,
      search: "",
      addedValue: []
    };
  },
  methods: {
    selectionHandler(v) {
      if (this.multiple) {
        if (this.value && this.value !== null && this.value.find(x => x == v)) {
          this.$emit(
            "input",
            this.value.filter(x => x != v)
          );
          this.$emit(
            "change",
            this.value.filter(x => x != v)
          );
        } else {
          this.$emit("input", this.value !== null ? [...this.value, v] : [v]);
          this.$emit("change", this.value !== null ? [...this.value, v] : [v]);
        }
      } else {
        if (this.value && this.value !== null && this.value == v) {
          this.$emit("input", null);
          this.$emit("change", null);
        } else {
          this.$emit("input", v);
          this.$emit("change", v);
        }
      }
      if (this.closeOnSelect) {
        this.dialog = false;
      }
    },
    isSelected(item) {
      if (this.multiple) {
        if (this.simpleItem) {
          return this.value && this.value !== null
            ? this.value.find(x => x === item)
              ? true
              : false
            : false;
        } else {
          return this.value && this.value !== null
            ? this.value.find(x => x === item[this.itemKey])
              ? true
              : false
            : false;
        }
      } else {
        if (this.simpleItem) {
          return this.value && this.value !== null
            ? this.value === item
            : false;
        } else {
          return this.value && this.value !== null
            ? this.value === item[this.itemKey]
            : false;
        }
      }
    },
    addValue() {
      let value = this.hashtag ? this.addHastag(this.search) : this.search;
      this.addedValue.push(value);
      if (this.multiple) {
        this.$emit(
          "input",
          this.value !== null ? [...this.value, value] : [value]
        );
        this.$emit(
          "change",
          this.value !== null ? [...this.value, value] : [value]
        );
      } else {
        this.$emit("input", value);
        this.$emit("change", value);
      }
      this.search = "";
    },
    addHastag(value) {
      let v = value;
      if (v.length > 0 && v.charAt(0) === "#") {
        return v;
      } else if (v.length > 0 && v.slice(-1)[0].charAt(0) !== "#") {
        return `#${v}`;
      } else {
        return v;
      }
    },
    compareSelected(a, b) {
      if (this.isSelected(a) === true && this.isSelected(b) === false)
        return -1;
      if (this.isSelected(a) === false && this.isSelected(b) === true) return 1;
      return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.j-select {
  width: 100%;
  .v-select {
    pointer-events: none !important;
  }
}
</style>
